import { FaWhatsapp } from "react-icons/fa";

function Topbar() {
    return (
    <div className="topbar">
        <div className="container topbar-inner">
        <div className="topbar-item">
            <span className="dot"></span>
            <span>Atendimento consultivo e personalizado</span>
        </div>
        <div className="topbar-actions">
            <a className="topbar-link" href="https://wa.me/5519995277000" target="_blank" rel="noopener"><FaWhatsapp className="topbar-icon" /></a>
        </div>
        </div>
    </div>
    )
}

export default Topbar;